import { render, staticRenderFns } from "./GatedContentDocuments.vue?vue&type=template&id=3f933ab2&scoped=true&"
import script from "./GatedContentDocuments.vue?vue&type=script&lang=js&"
export * from "./GatedContentDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f933ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f933ab2')) {
      api.createRecord('3f933ab2', component.options)
    } else {
      api.reload('3f933ab2', component.options)
    }
    module.hot.accept("./GatedContentDocuments.vue?vue&type=template&id=3f933ab2&scoped=true&", function () {
      api.rerender('3f933ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/GatedContentDocuments.vue"
export default component.exports